
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Hero from '@/components/Hero';
import Services from '@/components/Services';
import WhyUs from '@/components/WhyUs';
import BlogPreview from '@/components/BlogPreview';
import CallToAction from '@/components/CallToAction';
import ContactForm from '@/components/ContactForm';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { updateMetaTags, getCanonicalUrl } from '@/utils/seoUtils';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Index = () => {
  const { lang } = useParams<{ lang: string }>();
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];

  useEffect(() => {
    // Initialize AOS globally
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
    });

    // Add font-emoji style to help with flag display
    document.documentElement.classList.add('font-emoji');
    
    // Add a style tag to ensure emoji fonts are visible
    const style = document.createElement('style');
    style.textContent = `
      .font-emoji {
        font-family: "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif !important;
      }
    `;
    document.head.appendChild(style);

    // Update SEO meta tags
    updateMetaTags({
      title: t.pageTitle,
      description: t.pageDescription,
      keywords: "KI Video Marketing, Produktvideos, Social Media Videos, AI Videoproduktion Schweiz, Future Level",
      canonicalUrl: getCanonicalUrl('', currentLanguage),
      language: currentLanguage
    });
    
    return () => {
      // Clean up the style tag when the component unmounts
      document.head.removeChild(style);
    };
  }, [currentLanguage, t]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        {/* Perfect alignment with header using negative margin */}
        <div className="-mt-[64px]">
          <Hero />
        </div>
        {/* No gap between sections with margin-top: 0 */}
        <div className="bg-[#121212] mt-0">
          <Services />
          <WhyUs />
          <BlogPreview />
          <CallToAction />
          <div className="relative w-full overflow-hidden bg-gradient-to-b from-[#0A0A0A] to-[#111111]">
            <ContactForm />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
